module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/node_modules/@contentful/axios/index.js
// module id = ../../../../@contentful/axios/index.js
// module chunks = vendor